<template>
  <div class="contact-share">
    <div class="contact-share-text">
      <div class="contact-share-title">
        {{ companyName }} would like to contact you
      </div>
      <div class="contact-share-sub">
        Share your phone number and email with them for this job?
      </div>
    </div>
    <b-button
      variant="primary"
      class="contact-share-btn share-contact-btn"
      :disabled="busy"
      @click="$emit('share')"
    >
      Share my contact details
    </b-button>
  </div>
</template>

<script>
// The prompt shown to a shortlisted tradie when the company has asked for
// their contact details. Used on My applications and on the job page.
export default {
  name: 'ContactShareRequest',

  props: {
    companyName: { type: String, default: 'The company' },
    busy: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
.contact-share {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  margin-top: 0.9rem;
  padding: 0.9rem 1rem;
  background-color: #f2f7ff;
  border: 1px solid #d6e6ff;
  border-left: 4px solid #006cff;
  border-radius: 8px;
}

.contact-share-text {
  flex: 1 1 260px;
  min-width: 0;
}

.contact-share-title {
  font-weight: 600;
  color: #111827;
}

.contact-share-sub {
  font-size: 0.875rem;
  color: #4b5563;
}

// Override the global 56px-tall .btn so the label sits centred.
.contact-share-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding: 0 20px;
  font-weight: 600;
}
</style>
